import React from 'react';
import { ListItem, GridItem } from './Projects.Item';

const renderGridItem = ({ project, options, action1, name1, action2, name2, goToProject, isActive }) => {
  return (
    <GridItem
      project={project}
      options={options}
      name1={name1}
      action1={action1}
      name2={name2}
      action2={action2}
      goToProject={goToProject}
      isActive={isActive}
    />
  );
};

const renderListItem = ({ project, options, action1, name1, action2, name2, goToProject, isActive }) => {
  return (
    <ListItem
      project={project}
      options={options}
      name1={name1}
      action1={action1}
      name2={name2}
      action2={action2}
      goToProject={goToProject}
      isActive={isActive}
    />
  );
};

const ProjectsTable = ({ options, projects, action1, name1, action2, name2, goToProject, isActive }) => {
  if (options?.view === 'grid' || options?.view === '') {
    return (
      <div className="projects-list projects-list--grid">
        {projects.map(project => {
          return (
            <div
              key={`project-${project.weddingId}`}
              className="projects-list__item"
            >
              {renderGridItem({ project, options, action1, name1, action2, name2, goToProject, isActive })}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <>
      {projects?.map((project) => renderListItem({
        project, options, action1, name1, action2, name2, goToProject, isActive,
      }))}
    </>
  );
};

export default ProjectsTable;
